module.exports = {
    defaultLang: 'en',
    links: {
        buy: {
            domain: 'https://app.stormgain.com',
            deepLink: {
                path: 'deeplink.html',
                params:
                    'mobile=new-investment/PLACEHOLDER&desktop=%23modal_newInvest_PLACEHOLDER'
            }
        },
        cta: 'https://stormgain.com/LANGUAGE/crypto-trading'
    },
    wsgate: 'wss://ws-gate.stormgain.com/ws',
    quotes: 'https://quote.stormgain.com'
}
